import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type InternationalListData = AnyObject

export type InternationalListResponse = InternationalListData
export type InternationalListColumns = 'id' | 'name' | 'description' | 'country.id' | 'createdAt' | 'updatedAt';

export type InternationalListParams = PaginationProps<InternationalListColumns> & {
  search?: string;
  state?: number;
  city?: number;
}

const internationalListGetDefaultParams: InternationalListParams = {
  page: 1,
  pageSize: 10,
}

export const internationalList = (payload: InternationalListParams): Action<InternationalListParams> => ({
  type: actions.internationalListTrigger.toString(),
  payload,
});

export const internationalListClear = (): Action => ({
  type: actions.internationalListClear.toString(),
});

export const internationalListErrorClear = (): Action => ({
  type: actions.internationalListErrorReset.toString(),
});

export function* internationalListRequestSaga({ payload }: Action<InternationalListParams>) {
  yield put({
    type: actions.internationalListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.internationalListError.toString(),
      payload: {
        message: 'InternationalList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries({
    ...internationalListGetDefaultParams,
    ...payload
  })
    .map(([key, value]) => [key, value ? value.toString() : ''])
    .filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}internationals?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<InternationalListData, InternationalListResponse>(
    response,
    actions.internationalListSuccess.toString(),
    actions.internationalListError.toString(),
    false,
    (internationalListData) => internationalListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.internationalListTrigger.toString(),
    defaultProcessingSaga(
      internationalListRequestSaga,
      {
        error: actions.internationalListError.toString(),
        locationCancel: actions.internationalListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.internationalListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.internationalListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.internationalListErrorReset.toString(),
    });
  });
}
